import { i18nFormat as e } from "../../../constants/i18n.js";
import { intervalToDuration as _ } from "date-fns";
import o from "i18next";
import * as f from "ramda";
const y = (n, r) => {
  if (f.startsWith(e.FromNow, r)) {
    const t = Number(n);
    if (!isNaN(t)) {
      const {
        years: m = 0,
        months: i = 0,
        days: a = 0,
        hours: u = 0,
        minutes: s = 0,
        seconds: c = 0
      } = _({
        start: 0,
        end: Number(n) * 1e3
        // value must be in seconds
      });
      return m > 0 ? o.t("common.i18n_format.year", { count: m }) : i > 0 ? o.t("common.i18n_format.month", { count: i }) : a > 0 ? o.t("common.i18n_format.day", { count: a }) : u > 0 ? o.t("common.i18n_format.hour", { count: u }) : s > 0 ? o.t("common.i18n_format.minute", { count: s }) : c > 0 ? o.t("common.i18n_format.second", { count: c }) : o.t("common.i18n_format.just_now", { count: c });
    }
  }
  return null;
}, N = (n, r) => {
  if (f.startsWith(e.Ordinal, r)) {
    const t = Number(n);
    if (!isNaN(t))
      switch (t) {
        case 1:
          return o.t("common.i18n_format.ordinal_one", { count: t });
        case 2:
          return o.t("common.i18n_format.ordinal_two", { count: t });
        case 3:
          return o.t("common.i18n_format.ordinal_three", { count: t });
        default:
          return t >= 4 ? o.t("common.i18n_format.ordinal_many", { count: t }) : o.t("common.i18n_format.ordinal_zero", { count: t });
      }
  }
  return null;
}, p = (n, r) => {
  if (f.startsWith(e.RoundDays, r)) {
    const t = Number(n);
    if (!isNaN(t)) {
      const m = t / 86400;
      if (m >= 1)
        return o.t("common.i18n_format.day", {
          count: m
        });
      const i = t % (60 * 60 * 24);
      if (i >= 1)
        return o.t("common.i18n_format.hour", { count: i });
      const a = t % (60 * 60);
      if (a >= 0)
        return o.t("common.i18n_format.minute", { count: a });
      const u = t % 60;
      if (u >= 0)
        return o.t("common.i18n_format.second", { count: u });
    }
  }
  return null;
}, b = (n) => n > 1 ? o.t("common.i18n_format.year_old_other", { count: n }) : o.t("common.i18n_format.year_old", { count: n });
export {
  N as formatOrdinal,
  y as formatRelativeTime,
  p as formatRoundDays,
  b as formatYearOld
};
//# sourceMappingURL=format.js.map
